import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle2, Clock, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/public/arrival`;
const err = (e) => (typeof e?.response?.data?.detail === 'string' ? e.response.data.detail : 'Errore, riprova');

export default function ArrivalPage() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);
  const confirm = async () => {
    setBusy(true); setMsg('');
    try { setD((await axios.post(`${API}/${token}/confirm`)).data); } catch (e) { setMsg(err(e)); } finally { setBusy(false); }
  };
  useEffect(() => {
    let live = true;
    axios.get(`${API}/${token}`).then((r) => {
      if (!live) return;
      setD(r.data);
      if (r.data.can_confirm) { axios.post(`${API}/${token}/confirm`).then((c) => { if (live) setD(c.data); }).catch((e) => { if (live) setMsg(err(e)); }); }
    }).catch((e) => { if (live) setMsg(err(e)); });
    return () => { live = false; };
  }, [token]);
  if (!d) return <div className="min-h-screen bg-[#F6F3EE] grid place-items-center text-sm text-[#5F6570]" data-testid="arrival-loading">{msg || 'Caricamento…'}</div>;
  const where = [d.city, d.country].filter(Boolean).join(', ');
  return (
    <div className="min-h-screen bg-[#F6F3EE] text-[#14161A] py-10 px-4" data-testid="arrival-page">
      <div className="max-w-lg mx-auto bg-white border border-[#E3DED2] rounded-sm shadow-sm">
        <div className="bg-[#14161A] px-6 py-3 flex items-center justify-between gap-4"><img src={`${process.env.REACT_APP_BACKEND_URL}/api/assets/bond-logo.png`} alt="BOND" className="h-7" onError={(e) => { e.currentTarget.outerHTML = '<span style="color:#D4AF37;font-weight:800;letter-spacing:4px">BOND</span>'; }} /><img src="/travel-security-logo.png" alt="Smart Info Travel Security" className="h-12 sm:h-14 w-auto" data-testid="arrival-ts-logo" /></div>
        <div className="p-6 sm:p-8 text-center">
          {d.confirmed_at ? (
            <>
              <CheckCircle2 size={44} className="mx-auto text-[#2E9E6A] mb-3" />
              <h1 className="text-2xl font-bold mb-1" data-testid="arrival-confirmed">Arrivo confermato</h1>
              <p className="text-sm text-[#5F6570]">{d.traveler} · {where}<br />Confermato alle {d.confirmed_at} (ora locale). Buon lavoro e buon soggiorno.</p>
            </>
          ) : (
            <>
              <Clock size={40} className="mx-auto text-[#B8941F] mb-3" />
              <h1 className="text-2xl font-bold mb-1">Conferma di arrivo · {where}</h1>
              <p className="text-sm text-[#5F6570] mb-5">{d.traveler}{d.flight_no ? ` · volo ${d.flight_no}` : ''} · arrivo previsto {d.expected} · conferma entro {d.due} (ora locale)</p>
              {d.can_confirm
                ? <button onClick={confirm} disabled={busy} className="w-full h-12 bg-[#14161A] text-[#D4AF37] font-semibold rounded-sm inline-flex items-center justify-center gap-2" data-testid="arrival-confirm-btn">{busy && <Loader2 size={16} className="animate-spin" />}Confermo di essere arrivato</button>
                : <p className="text-sm text-[#5F6570]" data-testid="arrival-not-yet">Potrai confermare dalle {d.opens} (ora locale). Riapri questo link quando sei arrivato.</p>}
            </>
          )}
          {msg && <p className="text-sm text-[#B4372F] mt-4" data-testid="arrival-error">{msg}</p>}
        </div>
      </div>
    </div>
  );
}
